module.exports = __webpack_public_path__ + "static/img/bystage_white_07.e5f68ab6.svg";